import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=735b175a&scoped=true&"
import script from "./WidgetCard.vue?vue&type=script&lang=ts&"
export * from "./WidgetCard.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetCard.vue?vue&type=style&index=0&id=735b175a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b175a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VSpacer})
